import { REGEXP_ONLY_DIGITS } from "input-otp";
import { Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { zodResolver } from "@hookform/resolvers/zod";

const PinSchema = z.object({
	pin: z.string().min(6, {
		message: "Your pin must be 6 digits."
	})
});

interface PinVerificationProps {
	buttonLabel?: string;
	onSubmit: (pin: string) => Promise<void>;
	isPending: boolean;
}

export function PinVerification({ onSubmit, isPending, buttonLabel = "Submit" }: PinVerificationProps) {
	const form = useForm({
		resolver: zodResolver(PinSchema)
	});

	const handleSubmit = form.handleSubmit(async (values) => {
		await onSubmit(values.pin);
	});

	return (
		<Form {...form}>
			<form onSubmit={handleSubmit} className="space-y-6">
				<FormField
					name="pin"
					control={form.control}
					render={({ field }) => (
						<FormItem className="border-0">
							<FormControl>
								<InputOTP maxLength={6} {...field} pattern={REGEXP_ONLY_DIGITS}>
									<InputOTPGroup className="w-full justify-center gap-4 p-0">
										<InputOTPSlot index={0} className="border rounded  size-12" />
										<InputOTPSlot index={1} className="border rounded size-12" />
										<InputOTPSlot index={2} className="border rounded size-12" />
										<InputOTPSlot index={3} className="border rounded size-12" />
										<InputOTPSlot index={4} className="border rounded size-12" />
										<InputOTPSlot index={5} className="border rounded size-12" />
									</InputOTPGroup>
								</InputOTP>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
				<Button disabled={isPending} type="submit" className="h-14 w-full">
					{isPending
						? (
								<>
									<Loader2 size={20} className="animate-spin" />
									&nbsp; Loading....
								</>
							)
						: (
								buttonLabel
							)}
				</Button>
			</form>
		</Form>
	);
}
